export default "__VITE_ASSET__DbB9QOmU__"